export const ACTIVE_INCIDENTS_ACTIONS = {
  SET_STATE: 'set-state',
  ADD_NEW_INCIDENT: 'add-new-incident',
  REMOVE_ACTIVE_INCIDENT: 'remove-active-incidents',
  UPDATE_OIS: 'update-ois',
  ADD_OIS_TO_INCIDENT: 'add-ois-to-incident',
  UPDATE_DEPT_ATTRB: 'update-dept-attrb',
  SORT_ACTIVE_INCIDENTS: 'sort-active-incidents',
  ADD_OR_UPDATE_ACTIVE_INCIDENT: 'add-or-up-active-incident',
  REPLACE_ACTIVE_INCIDENT: 'replace-active-incident',
  UPDATE_ACTIVE_INCIDENT_PROPERTY: 'update-active-incident-property',
  REMOVE_OIS_FROM_ACTIVE_INCIDENT_TABLE: 'remove-ois-from-active-incident-table',
  UPDATE_OIS_DASH_MULTI_FIELD: 'update-ois-dash-multi-field'
}